import { addEventListener, DOM_EVENT } from '@datadog/js-core/dom'

export function onBFCacheRestore(callback: (event: PageTransitionEvent) => void): () => void {
  const { stop } = addEventListener(
    window,
    DOM_EVENT.PAGE_SHOW,
    (event: PageTransitionEvent) => {
      if (event.persisted) {
        callback(event)
      }
    },
    { capture: true }
  )
  return stop
}
